import React, { useState } from 'react'
import { firestore } from '../../firebase';
import SelectRegionHandler from './SelectRegionHandler';

function SearchBoligLight() {

    const [adresse, setAdresse] = useState("");
    const [region, setRegion] = useState();
    const [str, setStr] = useState(80);

    const [calculatedPrice, setCalculatedPrice] = useState(null);
    const [formattedCalculatedPrice, setFormattedCalculatedPrice] = useState(null);

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function searchHandler(e) {
        e.preventDefault();
        try {
            const calculatedPrice = priceCalculator();
            setCalculatedPrice(calculatedPrice);


            const searchRef = firestore.collection("prissok");
            const dateSearch = new Date().toISOString();
            const data = {
                adresse,
                region_id: region,
                date_search: dateSearch,
                calculated_price: calculatedPrice,
                str: +str,
                type: "light"
            }
            searchRef.add(data);
            setMessage("Søk lagt til");

        } catch (error) {
            setError("Kunne ikke fullføre søk");
        }
    }

    function priceCalculator() {

        const price = str * region;

        return price

    }

    function priceFormatter(price) {
        var parts = price.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    return (
        <React.Fragment>
            {calculatedPrice && (
                <div>
                    <h2 className="text-center font-weight-bold text-danger">{priceFormatter(calculatedPrice)} kr</h2>
                </div>
            )}
            <form onSubmit={searchHandler}>

                <label>Adresse</label>
                <input className="form-control mb-2" placeholder="Adresse" value={adresse} onChange={e => setAdresse(e.target.value)} />

                <SelectRegionHandler region={region} setRegion={setRegion} />

                <label>Antall kvadratmeter ({str} kvm)</label>
                <input type="range" className="form-control mb-2" value={str} max="1000" onChange={e => setStr(e.target.value)} />


                {error && <div className="alert alert-danger">{error} <span className="float-right" onClick={() => setError("")}>Lukk</span></div>}
                {message && <div className="alert alert-success">{message} <span className="float-right" onClick={() => setError("")}>Lukk</span></div>}
                <button className="btn btn-block btn-success">Søk</button>
            </form>
        </React.Fragment>
    )

}
export default SearchBoligLight